import { render, staticRenderFns } from "./ProductListGrid.vue?vue&type=template&id=b8630128"
import script from "./ProductListGrid.vue?vue&type=script&lang=js"
export * from "./ProductListGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductListGrid.vue?vue&type=style&index=0&id=b8630128&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports